/* global GeoPassThroughURL */

import {getTopLeft} from 'ol/extent';
import {get as getProjection} from 'ol/proj';
import OLWMTSSource from 'ol/source/WMTS';
import OLWMTSTileGrid from 'ol/tilegrid/WMTS';

import {useObject} from 'topmeteo/general/hooks';

import {useTileLayer} from './OpenLayers/hooks';

const URL = `${GeoPassThroughURL}/gwc/service/wmts`;
const ProjectionName = 'EPSG:900913';
const Projection = getProjection(ProjectionName);
const ProjectionExtent = Projection.getExtent();
const Origin = getTopLeft(ProjectionExtent);
const Resolutions = [
    156543.03390625,
    78271.516953125,
    39135.7584765625,
    19567.87923828125,
    9783.939619140625,
    4891.9698095703125,
    2445.9849047851562,
    1222.9924523925781,
    611.4962261962891,
    305.74811309814453,
    152.87405654907226,
    76.43702827453613,
    38.218514137268066,
];
const MatrixIDs = (new Array(Resolutions.length)).fill(null).map((elem, index) => `${ProjectionName}:${index}`);

const WMTSLayer = ({name, zIndex}) => {
    const source = useObject(() => new OLWMTSSource({
        url: URL,
        layer: `gdi:${name}`,
        tiled: true,
        matrixSet: ProjectionName,
        format: 'image/png',
        projection: Projection,
        tileGrid: new OLWMTSTileGrid({
            origin: Origin,
            resolutions: Resolutions,
            matrixIds: MatrixIDs,
        }),
    }), [name]);

    useTileLayer({preload: 10, source, zIndex}, []);

    return null;
};

export default WMTSLayer;
